export default {
  path: 'home-school',
  name: 'HomeSchool',
  component: () => import('./HomeSchool.vue'),
  redirect: { name: 'HomeworkList' },
  children: [
    {
      path: '',
      redirect: { name: 'HomeworkList' },
    },
    {
      path: 'homework-list',
      name: 'HomeworkList',
      component: () => import('./views/HomeworkList.vue'),
      meta: {
        title: '作业列表',
      },
    },
    {
      path: 'publish',
      name: 'PublishHomework',
      component: () => import('./views/PublishHomework.vue'),
      meta: {
        title: '发布作业',
      },
    },
    {
      path: 'detail/:homeworkId',
      name: 'HomeworkDetail',
      component: () => import('./views/HomeworkDetail.vue'),
      meta: {
        title: '作业详情',
      },
    },
    {
      path: 'review/:homeworkId/:submissionId',
      name: 'ReviewHomework',
      component: () => import('./views/ReviewHomework.vue'),
      meta: {
        title: '批阅作业',
      },
    },
    {
      path: 'student-list',
      name: 'StudentHomeworkList',
      component: () => import('./views/StudentHomeworkList.vue'),
      meta: {
        title: '我的作业',
      },
    },
    {
      path: 'student-detail/:homeworkId',
      name: 'StudentHomeworkDetail',
      component: () => import('./views/StudentHomeworkDetail.vue'),
      meta: {
        title: '作业详情',
      },
    },
  ],
};
